var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenRotate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#5f6368",
    style: {
      padding: 3
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M516-191 191-516q-18-20-18-46t18-46l166-165q18-20 45-20t47 20l325 325q19 19 19 46t-19 46L608-191q-18 20-45 20t-47-20Zm14-701 107 107q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9L419-917q-11-11-6-24t19-16q11-2 23-2.5t23-.5q100 0 187.5 38t153 103.5Q884-753 922-665.5T960-478q0 13-8.5 21.5T930-448q-13 0-21.5-8.5T900-478q0-80-28-151.5T794.5-757Q745-813 677-848.5T530-892ZM433-66 324-175q-9-9-8.5-21t9.5-21q9-9 21.5-9t21.5 9L540-45q11 11 6 25.5T526-2q-12 2-24 2.5T478 1q-99 0-186-37.5t-152-103Q75-205 37.5-292T0-478q0-13 8.5-21.5T30-508q13 0 21.5 8.5T60-478q0 80 28.5 151.5t78.5 127Q217-144 285.5-109T433-66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenRotate);
export default __webpack_public_path__ + "static/media/screen-rotate.3f8f55bdc5bb8f89186aa12725144c74.svg";
export { ForwardRef as ReactComponent };